import { render, staticRenderFns } from "./WeekEmojiReactions.vue?vue&type=template&id=bf700990&"
import script from "./WeekEmojiReactions.vue?vue&type=script&lang=js&"
export * from "./WeekEmojiReactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports